import { useEffect, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminApp } from "@/hooks/useAdminApp";
import { useStateMachineValue } from "@/core/arch/state_machine";
import { ROUTES } from "@/routes";
import { Loader2 } from "lucide-react";

export function AdminAuthGuard({ children }: { children: ReactNode }) {
  const { adminUserBloc } = useAdminApp();
  const [state] = useStateMachineValue(adminUserBloc);
  const navigate = useNavigate();

  useEffect(() => {
    adminUserBloc.checkAuth();
  }, [adminUserBloc]);

  useEffect(() => {
    if (state.status === "unauthenticated") {
      navigate(ROUTES.LOGIN, { replace: true });
    } else if (state.status === "access_denied") {
      navigate(`${ROUTES.LOGIN}?error=access_denied`, { replace: true });
    }
  }, [state.status, navigate]);

  if (state.status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (state.status !== "authenticated") {
    return null;
  }

  return <>{children}</>;
}
